import React, { useState, useEffect, useMemo } from "react";
import { FaToggleOn, FaToggleOff } from "react-icons/fa";
import { TbEdit,TbEye } from "react-icons/tb";
import { toast } from "react-toastify";
import { MdDeleteOutline,MdCheckCircle, MdWarning, MdError } from "react-icons/md";

const UserDetails = () => {
  const [formData, setFormData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [addUserModel, setAddUserModel] = useState(false);
  const [editFormModel, setEditFormModel] = useState(false);
  const [itemToEdit, setItemToEdit] = useState(null);
  const [itemToView, setItemToView] = useState(null);
  const [activeModalShow, setActiveModalShow] = useState(false);
  const [itemToActive, setItemToActive] = useState(null);

  const itemsPerPage = 20;

  const Auth = localStorage.getItem("authToken");

  useEffect(() => {
    fetchFormData();
  }, []);
  // fetch the all data
  const fetchFormData = async () => {
    try {
      const response = await fetch("https://support.ace-school-backend.serverscripts.in/api/v1/admin/subscription/view", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        },
      });

      if (!response.ok) throw new Error("Failed to fetch form data");
      
      const result = await response.json();
      setFormData(result.data || []);
      setLoading(false);
    } catch (err) {
      //console.error("Something went wrong");
      setError(err.message);
      setLoading(false);
    }
  };

  
  const filteredFormData = useMemo(() => {
    const today = new Date();
    let filtered = formData.filter((u) => {
      const nameMatch = u.schoolName?.toLowerCase().includes(search.toLowerCase()) || u.user_name?.toLowerCase().includes(search.toLowerCase());
      

      return nameMatch ;
    });

    
    

    return filtered;
  }, [formData, search]);

  // Pagination Method
  const totalPages = Math.ceil(filteredFormData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentFormData = filteredFormData.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;


  return (
    <div className="Task-Details-Container">
      <h2 className="text-xl font-semibold mb-4">Subscription Lists</h2>
      <div className="flex justify-between items-center mb-4">
      
        <div className="flex justify-end flex-end gap-4 mb-4">
          <input
            type="text"
            placeholder="Search by user name..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
            className="px-4 py-2 border rounded"
          />
          

          
        </div>
      </div>

      
      <table className="w-full text-sm border user-table">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left">#</th>
            <th className="px-4 py-2 text-left">User Name</th>
            <th className="px-4 py-2 text-left">School Name</th>
            <th className="px-4 py-2 text-left">Subscription Type</th>
            <th className="px-4 py-2 text-left">Package Name</th>
            <th className="px-4 py-2 text-left">Start Date</th>
            <th className="px-4 py-2 text-left">Expiry Date</th>
          </tr>
        </thead>
        <tbody>
          {currentFormData.length > 0 ? (
            currentFormData.map((f, index) => (
              <tr key={f.id || index} className="border-t">
                <td className="px-4 py-2">{startIndex + index + 1}</td>
                <td className="px-4 py-2">
                  <div className="flex items-center space-x-2">
                    {(() => {
                      const status = getStatus(f.expiry_date);

                      let badgeClass = "";
                      let label = "";
                      let Icon = null;
                      let extraClass = "";

                      if (status === "expired") {
                        badgeClass = "bg-red-100 text-red-600";
                        label = "Expired";
                        Icon = MdError;
                      } else if (status === "expiring") {
                        badgeClass = "bg-yellow-100 text-yellow-700";
                        label = "Expiring Soon";
                        Icon = MdWarning;
                        extraClass = "blink-soft";
                      } else {
                        badgeClass = "bg-green-100 text-green-600";
                        label = "Active";
                        Icon = MdCheckCircle;
                      }

                      return (
                        <>
                          <span className={`flex items-center gap-1 px-2 py-1 text-xs rounded-full font-semibold ${badgeClass}`}>
                            {Icon && <Icon size={14}  className={extraClass} />}
                            {label}
                          </span>

                          <span>{f.user_name || "N/A"}</span>
                        </>
                      );
                    })()}
                  </div>
                </td>
                <td className="px-4 py-2">{f.schoolName || "N/A"}</td>
                <td className="px-4 py-2"> {f.type || "N/A"}</td>
                <td className="px-4 py-2">{f.packageName || "N/A"}</td>
                <td className="px-4 py-2">{f.start_date || "N/A"}</td>
                <td className="px-4 py-2">{f.expiry_date || "N/A"}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center py-4 text-gray-500">
                No form data found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      
      <div className="flex justify-center mt-4 gap-2 items-center">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === 1}
        >
          Prev
        </button>

        <span className="ml-4 text-sm text-gray-600">
          Page {currentPage} / {totalPages || 1}
        </span>

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
      

      
    </div>
  );
};

export default UserDetails;


const formatDateTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return isNaN(date.getTime()) ? "" : date.toLocaleString();
};

const getStatus = (expiryDate) => {
  if (!expiryDate) return "unknown";

  const today = new Date();
  const exp = new Date(expiryDate);

  today.setHours(0, 0, 0, 0);
  exp.setHours(0, 0, 0, 0);

  const diffTime = exp - today;
  const diffDays = diffTime / (1000 * 60 * 60 * 24);

  if (diffDays < 0) return "expired";
  if (diffDays <= 7) return "expiring"; 
  return "active";
};
